<template>
  <v-select
    outlined
    clearable
    v-model="selected"
    :items="columns"
    :menu-props="{ maxHeight: '200', zIndex: 13 }"
    label="Dans la colonne"
  ></v-select>
</template>

<script>
import { computed, onMounted, reactive, watch } from "@vue/composition-api";

import useProxy from "@/hooks/useProxy";
import useQueryString from "@/hooks/useQueryString";

import { URL_PARAM_NAMES } from "@/utils/constants";

const COMPONENT_NAME = "SearchColumn";

/**
 * Call this component specifying a `store`
 *  (and eventually `storeGetter`/`storeUpdater`)
 */
export default {
  name: COMPONENT_NAME,
  props: {
    columns: {
      type: Array,
      validator(values) {
        return (
          values.length > 0 ||
          values.every((value) => typeof value === "string")
        );
      },
    },
    store: {
      type: String,
      validator(value) {
        /* List of stores having :
        - getters["<store>/<storeGetter>"]
        - dispatch("<store>/<storeUpdater>", payload)
        */
        return ["audience", "regie"].includes(value);
      },
    },
    storeGetter: {
      type: String,
      default: "getSearchColumn",
    },
    storeUpdater: {
      type: String,
      default: "updateSearchColumn",
    },
    anchor: {
      type: String,
      default: "",
    },
  },
  setup(props, { emit }) {
    const { store } = useProxy();

    const { addQueryStringParam, synchronizeFilterWithQueryString } =
      useQueryString();

    const page = reactive({
      isInitialized: false,
    });

    // =>  METHODS

    // =>  COMPUTED
    const selected = computed({
      get() {
        return store.getters[`${props.store}/${props.storeGetter}`];
      },
      set(e) {
        store.dispatch(`${props.store}/${props.storeUpdater}`, e);
      },
    });

    // =>  WATCH
    watch(selected, (newValue) => {
      if (page.isInitialized) {
        // Only update user changes, not initialization
        addQueryStringParam(
          {
            param: URL_PARAM_NAMES[COMPONENT_NAME],
            value: newValue,
            // is_multiple: false,
            // is_integer: false,
            // is_boolean: false,
          },
          props.anchor
        );
      }
    });

    // =>  HOOKS
    onMounted(async () => {
      await synchronizeFilterWithQueryString({
        dispatcher: `${props.store}/${props.storeUpdater}`,
        param: URL_PARAM_NAMES[COMPONENT_NAME],
        value: selected.value,
        // is_multiple: false,
        // is_integer: false,
        // is_boolean: false,
        // dependsOn: undefined,
      });

      page.isInitialized = true;
    });

    // =>  DATA
    return {
      selected,
    };
  },
};
</script>

<style scoped></style>
